import Input from "@/ui/input";
import { IconComponent } from "@/ui/icon";
import GradientBorderRadius from "@/ui/gradient-border-radius";
import OrdersFiltersModal from "@/features/filters-modals/orders-filters-modal";
import WalletSelect from "@/features/wallet-select";
import { useOrdersFilter } from "@/providers/orders-filter/orders-filter";
import TokenValueToggle, {
  TokenValueToggleView,
} from "@/features/token-value-toggle/token-value-toggle";

const OrdersHeader = ({
  selectedView,
  setSelectedView,
}: {
  selectedView: TokenValueToggleView;
  setSelectedView: (view: TokenValueToggleView) => void;
}) => {
  const { searchInput, setSearchInput } = useOrdersFilter();

  return (
    <div className="relative w-full flex justify-between items-center px-[0.625rem]">
      <div className="flex justify-center items-center gap-[0.3125rem]">
        <WalletSelect />
        <div className="flex justify-center items-center gap-[0.3125rem]">
          <div className=" h-[1.45rem]  w-[25rem] group">
            <Input
              className="pl-[0.25rem]  font-semibold group placeholder:text-white"
              placeholder="Token"
              value={searchInput}
              onChange={setSearchInput}
              rightSide={
                <GradientBorderRadius
                  radius="left"
                  gradient="input-50"
                  hover="input-50"
                >
                  <div className="w-[1.375rem] h-[1.375rem] flex justify-center items-center">
                    <IconComponent
                      name="search"
                      className="w-[0.75rem] h-[0.75rem]"
                    />
                  </div>
                </GradientBorderRadius>
              }
            />
          </div>
        </div>
      </div>
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
        <div className="text-base leading-[0.625rem] font-semibold">Orders</div>
      </div>
      <div className="flex justify-center items-center gap-[0.625rem]">
        <TokenValueToggle
          selectedView={selectedView}
          setSelectedView={setSelectedView}
        />

        <OrdersFiltersModal />
      </div>
    </div>
  );
};

export default OrdersHeader;
